
import Api from '@/utils/api';
import MHeader from '../../Header/Header.vue';
import NotData from '../../NoData/NoData.vue';
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

import {
getCollectAll,
cancalCollect,
changeShop
} from '../../../api';
export default {
data() {
return {
list2: ['收藏商品', '收藏店铺'],
index: 0,
h: "",
w: "",
favList1: [],
favList2: [],
show1: false,
shop_id: "",
favoritesList: []
}
},
computed: {
list1() {
return Object.keys(this.favList1);
}
},
components: {
MHeader,
Tab,
TabItem,
Swiper,
SwiperItem,
ViewBox,
NotData,
XImg,
Confirm
},
methods: {
start() {
Api.getFavoritesList()
.then(res => {
this.favoritesList = res.data
})
},

deleteFavorite(item, index) {
const that = this
this.$vux.confirm.show({
title: '删除',
content: '确认要删除此收藏',
onShow () {
console.log('plugin show')
},
onHide () {
console.log('plugin hide')
},
onCancel () {
console.log('plugin cancel')
},
onConfirm () {
Api.deleteFavorite(item.product._id)
.then(res => {
that.favoritesList.splice(index, 1)
})
}
})
},
colectTap(item_id) {
cancalCollect(`item_id=${item_id}`).then(res => {
this.$store.commit('updateToast', {
show: true,
text: res.data.msg
});
if (!res.data.error_code) {
this.$delete(this.favList1, item_id)
};
})
},
switchShop(shop_id) {
this.shop_id = shop_id;
this.show1 = true;
},
confirm() {
changeShop(this.shop_id).then(res => {
console.error(res);
});
this.$router.push({
name: "home"
});
window.location.reload();
},
share() {
this.$vux.alert.show({
title: '分享店铺',
content: '点击切换店铺，切换完成。点击右上方按钮选择分享，就能分享当前所选店铺啦！'
})
},
delShop(res, index) {
const _this = this 
this.$vux.confirm.show({

title: "提示",
content: "是否要删除店铺？",
onConfirm() {
res.splice(index, 1);
}
})
}
},
created() {
this.h = document.documentElement.clientHeight - 0.88 * parseInt(document.documentElement.style.fontSize) + 'px';
this.w = document.documentElement.clientWidth;
this.start()
}

};



// WEBPACK FOOTER //
// ./src/components/UserCenter/collectList/collectList.vue